// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"213ecde9","833":"2bd3c81c"}[chunkId] + ".chunk.js";
};